<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @success="onSuccess"
      :submitService="submitService"
      :submitData="submitData"
      :showDownloadPower="true"
      @openAddDialog="handleExport"
      buttonType="warning"
      buttonName="导出"
      addShowPower="/fin/exportTatAssets"
      showDownloadPowerType="purple"
      downloadPowerText="合计"
      downloadPower="/statistics/tatAssets"
      @down="down"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatSimpleName"
        label="机构简称"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="incomeTotalAcct"
        label="总收入账户（元）"
        :formatter="formatterTableNumber"
        min-width="150"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cashAcct"
        label="可用账户（元）"
        min-width="130"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="frozenAcct"
        label="冻结账户（元）"
        min-width="130"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="awardAcct"
        label="奖励金账户（元）"
        min-width="150"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="fakeAcct"
        label="营销账户（元）"
        min-width="150"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="outcomeAcct"
        label="支出账户（元）"
        min-width="130"
        :formatter="formatterTableNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="160"
        v-if="hasPerm('/fin/adjust') || hasPerm('/tatacct/closeTempAcct')"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="updateInfo(scope.row.id, scope.row.tatSimpleName, 1)"
            v-if="hasPerm('/tatacct/closeTempAcct')"
            >结算</el-button
          >
          <el-button
            type="text"
            @click="updateInfo(scope.row.tatId, scope.row.tatSimpleName, 2)"
            v-if="hasPerm('/fin/adjust')"
            >调账</el-button
          >
          <el-button
            type="text"
            @click="updateInfo(scope.row.tatId, scope.row.tatSimpleName, 4)"
            v-if="hasPerm('/fin/adjust')"
            >冻结</el-button
          >
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="formDialogTitle"
      :model="dialogModel"
      :show="dialogType != 3"
      submitBtnText="结算"
      :showPower="dialogType == 2 || dialogType == 4"
      @cancelChecked="cancelChecked"
      :submitData="dialogData"
      :rules="dialogType == 4 ? frozenRules : dialogRules"
      :dialogService="dialogService"
      @success="dialogSuccess"
      @close="dialogClose"
      @opend="dialogOpen"
      class="note"
    >
      <div class="dialog_detail" v-if="dialogType == 1">
        <p class="tat-title" v-for="(item, index) in tempAcctArr">
          <span>{{ item.label }}：</span>{{ item.value }}元
        </p>
      </div>
      <!--结算-->
      <div class="dialog_detail" v-else-if="dialogType == 3">
        <p class="tat-title">
          <span>总收入：</span>{{ toDoubleThousands(dialogObj.incomeAcct) }}元
        </p>
        <p class="tat-title">
          <span>可用账户：</span>{{ toDoubleThousands(dialogObj.cashAcct) }}元
        </p>
        <p class="tat-title">
          <span>支出账户：</span
          >{{ toDoubleThousands(dialogObj.outcomeAcct) }}元
        </p>
      </div>
      <!--合计-->
      <div v-else-if="dialogType == 2">
        <p class="tat-title"><span>机构简称：</span>{{ getTatName }}</p>
        <el-form-item label="调账类型" prop="adjustType">
          <el-select v-model="dialogModel.adjustType">
            <el-option
              v-for="item in dialogTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div v-if="isPhone">
          <el-form-item
            label="分润类型"
            prop="operation"
            v-if="isOperation || needOrderId"
          >
            <el-select v-model="dialogModel.operation">
              <el-option
                v-for="item in profitList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="dialogModel.adjustType != 6">
            <el-form-item label="电话号码" prop="phone">
              <el-input
                type="textarea"
                v-model="dialogModel.phone"
                rows="5"
                placeholder="请输入会员电话号码，多个号码以‘,’分割"
              ></el-input>
            </el-form-item>
            <div class="flex-row vertical-center mem-name">
              <p>会员名称：</p>
              <p v-if="memName">{{ memName }}</p>
            </div>
          </div>
          <div v-if="dialogModel.adjustType == 6">
            <el-form-item label="出款电话号" prop="phone">
              <el-input
                v-model="dialogModel.phone"
                show-word-limit
                placeholder="请输入电话号"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <div class="flex-row vertical-center mem-name">
              <p>会员名称：</p>
              <p v-if="memName">{{ memName }}</p>
            </div>
            <div class="flex-row vertical-center mem-name">
              <p>可提现余额：</p>
              <p v-if="money">{{ money }}</p>
            </div>
            <el-form-item label="入款电话号" prop="toMemId">
              <el-input
                v-model="dialogModel.toMemId"
                show-word-limit
                placeholder="请输入电话号"
                maxlength="11"
              ></el-input>
            </el-form-item>
            <div class="flex-row vertical-center mem-name">
              <p>会员名称：</p>
              <p v-if="memNames">{{ memNames }}</p>
            </div>
            <div class="flex-row vertical-center mem-name">
              <p>可提现余额：</p>
              <p v-if="moneys">{{ moneys }}</p>
            </div>
          </div>
        </div>
        <el-form-item label="订单号" prop="orderId" v-if="needOrderId">
          <el-input
            type="text"
            v-model="dialogModel.orderId"
            show-word-limit
            placeholder="请输入订单号"
          ></el-input>
        </el-form-item>
        <el-form-item label="调账金额" prop="adjustAmt">
          <el-input-number
            v-model="dialogModel.adjustAmt"
            :controls="false"
            controls-position="right"
            :precision="2"
            :step="0.1"
            @change="handleChange"
            :min="0"
            style="width: 91%"
          ></el-input-number>
          <span>元</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            maxlength="80"
            show-word-limit
            v-model="dialogModel.remark"
            type="textarea"
            resize="none"
            rows="3"
          ></el-input>
        </el-form-item>
      </div>
      <!--调账-->
      <div v-else>
        <p class="tat-title"><span>机构简称：</span>{{ getTatName }}</p>
        <el-form-item label="操作类型" prop="tranType">
          <el-select v-model="dialogModel.tranType">
            <el-option
              v-for="item in tranTypeArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="调账金额" prop="tatAmount">
          <el-input-number
            v-model="dialogModel.tatAmount"
            :controls="false"
            controls-position="right"
            :precision="2"
            :step="0.1"
            @change="handleChange"
            :min="0"
            style="width: 91%"
          ></el-input-number>
          <span>元</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            maxlength="80"
            show-word-limit
            v-model="dialogModel.remark"
            type="textarea"
            resize="none"
            rows="3"
          ></el-input>
        </el-form-item>
      </div>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import FormDialog from "../../dialog/FormDialog";
import TranTypes from "service/constant/TranTypes";

import FinanceService from "service/FinanceService";
import StatisticsService from "service/StatisticsService";
import OrganService from "service/OrganService";
import AccAdjTypes from "service/constant/AccAdjTypes";
import privateKey from "service/constant/privateKey";
import Regs from "common/conf/Regs";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "accountmanage",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
    SelectOrgans,
  },
  data() {
    return {
      formModel: {
        tatSimpleId: "",
      },
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      tableData: [{}],
      formDialogTitle: "",
      dialogModel: {
        tranType: "",
        tatAmount: "0",
        adjustType: "",
        operation: "",
        adjustAmt: "0",
        remark: "",
        phone: "",
        toMemId: "",
        orderId: "",
      },
      frozenRules: {
        tranType: [
          {
            required: true,
            message: "请选择操作类型",
          },
        ],
      },
      dialogRules: {
        adjustType: [
          {
            required: true,
            message: "请选择调账类型",
          },
        ],
        adjustAmt: [
          {
            required: true,
            message: "请输入调账金额",
          },
        ],
        operation: [
          {
            required: true,
            message: "请选择分润类型",
          },
        ],
        orderId: [
          {
            required: this.needOrderId,
            message: "请输入订单号",
          },
        ],
        phone: [
          {
            required: this.isPhone,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入电话号码"));
              } else if (
                value.split(",").some((item) => !Regs.phone.test(item))
              ) {
                callback(new Error("请输入正确的11位手机号码"));
              } else {
                if (this.dialogModel.adjustType != 6) {
                  this.getRealNameByPhone(value, (res) => {
                    if (res.respCode == "0000") {
                      this.memName = res.contents.realNames;
                      this.memId = res.contents.userIds;
                      return callback();
                    } else {
                      callback(new Error("查询不到此用户"));
                      this.memName = "";
                      this.memId = "";
                    }
                  });
                } else {
                  this.getNamePhoneNumber(value, (res) => {
                    if (res.respCode == "0000") {
                      this.memName = res.contents.realNames;
                      this.money = res.contents.money;
                      this.memId = res.contents.userIds;
                      return callback();
                    } else {
                      callback(new Error("查询不到此用户"));
                      this.memName = "";
                      this.money = "";
                      this.memId = "";
                    }
                  });
                }
              }
            },
          },
        ],
        toMemId: [
          {
            required: this.isPhone,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入电话号码"));
              } else if (
                value.split(",").some((item) => !Regs.phone.test(item))
              ) {
                callback(new Error("请输入正确的11位手机号码"));
              } else {
                if (this.dialogModel.adjustType != 6) {
                  this.getRealNameByPhone(value, (res) => {
                    if (res.respCode == "0000") {
                      this.memNames = res.contents.realNames;
                      this.toMemId = res.contents.userIds;
                      return callback();
                    } else {
                      callback(new Error("查询不到此用户"));
                      this.memNames = "";
                      this.toMemId = "";
                    }
                  });
                } else {
                  this.getNamePhoneNumber(value, (res) => {
                    if (res.respCode == "0000") {
                      this.memNames = res.contents.realNames;
                      this.moneys = res.contents.money;
                      this.toMemId = res.contents.userIds;
                      return callback();
                    } else {
                      callback(new Error("查询不到此用户"));
                      this.memName = "";
                      this.moneys = "";
                      this.toMemId = "";
                    }
                  });
                }
              }
            },
          },
        ],
      },
      params: {},
      page: {},
      adjustId: "",
      submitService: FinanceService.getTatAssets,
      dialogService: null,
      getTatName: "",
      memName: "",
      money: "",
      moneys: "",
      memNames: "",
      memId: "",
      toMemId: "",
      dialogObj: {},
      isPage: false,
      tempAcctArr: [],
      tranTypeArr: [],
      operations: [],
      profitArr: [],
      dialogType: 1,
    };
  },
  mixins: [loadMixin, dialogMixin],
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.tranTypeArr = TranTypes.slice(13, 16);
    this.getTypeNames("移动业务", (res) => {
      this.operations = res;
    });
    this.getTypeNames("手动分润", (res) => {
      this.profitArr = res;
    });
    this.getList();
  },
  computed: {
    profitList() {
      return this.dialogModel.adjustType == 5
        ? this.profitArr
        : this.operations;
    },
    dialogTypes() {
      return AccAdjTypes.splice(1, AccAdjTypes.length);
    },
    isPhone() {
      return (
        this.dialogModel.adjustType != 3 && this.dialogModel.adjustType != 4
      );
    },
    needOrderId() {
      return this.dialogModel.adjustType == 5;
    },
    isOperation() {
      return (
        this.dialogModel.adjustType == 2 || this.dialogModel.adjustType == 6
      );
    },
    submitData() {
      const params = {
        userId: this.userId,
        tatSimpleId: this.formModel.tatSimpleId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return params;
    },
    dialogData() {
      if (this.dialogType == 4) {
        return {
          userId: this.userId,
          tatSimpleId: this.adjustId,
          tranType: this.dialogModel.tranType,
          tatAmount: parseInt(this.dialogModel.tatAmount * 100),
          remark: this.dialogModel.remark.trim(),
        };
      }

      if (this.dialogType == 1) {
        this.params = {
          userId: this.userId,
          id: this.adjustId,
        };
      } else {
        this.params = {
          userId: this.userId,
          tatSimpleId: this.adjustId,
          memId: this.memId,
          toMemId: this.toMemId,
          adjustType: this.dialogModel.adjustType,
          operation: this.dialogModel.operation,
          adjustAmt: this.dialogModel.adjustAmt,
          orderId: this.dialogModel.orderId,
          remark: this.dialogModel.remark.trim(),
        };
      }
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    "dialogModel.adjustType"(val, oldVal) {
      if (val) {
        this.dialogModel = {
          tranType: "",
          tatAmount: "0",
          tatSimpleId: "",
          adjustType: val,
          operation: "",
          orderId: "",
          adjustAmt: "0",
          remark: "",
        };
        this.memName = "";
        this.money = "";
        this.moneys = "";
        this.memNames = "";
        this.memId = "";
        this.toMemId = "";
        this.dialogObj = {};
      }
    },
  },
  methods: {
    handleExport() {
      this.limitExport(this.page.total)
        ? StatisticsService.exportExcel(
            this.submitData,
            "exportTatAssets",
            "",
            "/fin/"
          )
        : "";
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        FinanceService.getTatAssets,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.tableData = result.rows;

            this.page.currentPage = result.current;
            this.page.pageSize = result.size;
            this.page.total = result.total;
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    down() {
      this.doLoad(
        StatisticsService.statisTatAssets,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.dialogObj = result;
            this.$nextTick(() => {
              this.formDialogTitle = "合计";
              this.dialogType = 3;
              this.$refs.formDialog.open();
            });
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.pageSize = result.size;
        this.page.total = result.total;
      });
    },
    updateInfo(id, name, type) {
      this.getTatName = name;
      this.adjustId = id;
      this.dialogType = type;
      this.dialogService =
        this.dialogType == 1
          ? FinanceService.closeTempAcct
          : this.dialogType == 2
          ? FinanceService.adjust
          : FinanceService.frozen;
      this.formDialogTitle =
        this.dialogType == 1 ? "结算" : this.dialogType == 2 ? "调账" : "冻结";
      this.$refs.formDialog.open();
      console.log("dialogTypes", this.dialogTypes);
    },
    selectTempAcct() {
      this.doLoad(
        FinanceService.selectTempAcct,
        {
          id: this.adjustId,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.tempAcctArr = res.contents;
          });
        },
        "信息获取失败"
      );
    },
    dialogSuccess(data) {
      if (!data) {
        let total = 0;
        this.tempAcctArr.forEach((item) => {
          if (item.label == "合计收益") {
            total = item.value;
          }
        });
        if (total == 0) {
          this.showError("合计收益不足，暂不能进行结算操作");
        } else {
          this.closeTempAcct();
        }
      } else {
        this.doCheck(data, (res) => {
          console.log(res);
          const result = res.contents;
          this.showSuccess(result.optMsg || res.respMsg);
          this.$refs.formDialog.closeDialog();
          this.getList();
        });
      }
    },
    closeTempAcct() {
      this.doLoad(
        FinanceService.closeTempAcct,
        this.dialogData,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            if (result.optStatus == "0000") {
              this.showSuccess(result.optMsg);
              this.$refs.formDialog.closeDialog();
              this.getList();
            } else {
              this.showError(result.optMsg);
            }
          });
        },
        "信息获取失败"
      );
    },
    dialogClose() {
      this.dialogModel = {
        tranType: "",
        tatAmount: "0",
        tatSimpleId: "",
        adjustType: "",
        operation: "",
        orderId: "",
        adjustAmt: "0",
        remark: "",
      };
      this.memName = "";
      this.money = "";
      this.moneys = "";
      this.memNames = "";
      this.memId = "";
      this.toMemId = "";
      this.dialogObj = {};
    },
    cancelChecked() {
      this.$refs.formDialog.dialogFormVisible = false;
    },
    getRealNameByPhone(val, onSuccess) {
      const params = {
        tatSimpleId: this.adjustId,
        phone: val,
      };
      this.doLoad(
        FinanceService.getRealNameByPhones,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    getNamePhoneNumber(val, onSuccess) {
      const params = {
        tatSimpleId: this.adjustId,
        phone: val,
      };
      this.doLoad(
        FinanceService.getNamePhoneNumber,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    dialogOpen() {
      if (this.dialogType == 1) {
        this.selectTempAcct();
      }
    },
    handleChange() {},
  },
};
</script>

<style scoped>
.dialog_detail .tat-title {
  margin-bottom: 0;
}

.tat-title {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.tat-title span {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}

.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/AccountManage.vue